import styled from 'styled-components';

export const PolicyWrapper = styled.div``;
